import { director, _decorator, CCString } from 'cc';
import Lobby from '../../System/Lobby';
import PreloadView from '../UI/PreloadView';
import PreloadFlow from '../../../common/scripts/PreloadFlow';
import ErrorName from '../../../common/scripts/ErrorHandler/ErrorName';
import LoadingTask from '../../../common/scripts/Toolkit/Helper/Loading/LoadingTask/LoadingTask';
import GameDependency from '../../../common/scripts/System/GameDependency';
import { EnterTableOption } from '../../../tableEngine/Script/Game/Data/Model/HallModel';
import enterTableFlow from './EnterTableFlow';
import { FeatureActivityDataType } from '../Data/Config/FeatureActivityConfig';
import { SceneName } from '../Data/Config/SceneNodeName';

const { ccclass, property } = _decorator;

@ccclass('PreloadController')
export default class PreloadController extends GameDependency {
    @property(CCString)
    protected readonly gameSceneName: string = 'Game';

    @property(PreloadView)
    private readonly preloadView: PreloadView = null;

    private _loadingProgress: number = 0;
    private _connectProgress: number = 0;

    protected get loadingProgress(): number {
        return this._loadingProgress;
    }
    protected set loadingProgress(value: number) {
        if (this._loadingProgress === value) {
            return;
        }
        this._loadingProgress = value;
        this._updateProgress();
    }

    protected get connectProgress(): number {
        return this._connectProgress;
    }
    protected set connectProgress(value: number) {
        if (this._connectProgress === value) {
            return;
        }
        this._connectProgress = value;
        this._updateProgress();
    }

    protected async onLoad() {
        await this.game.waitForLaunched;
        const loadingTask = PreloadFlow.start(this.gameSceneName, this.game);
        loadingTask.on(LoadingTask.EVENT_TYPE.Progress, (progress: number) => {
            this.loadingProgress = progress;
        });

        // wait for splash animation end
        if ((window as any).logoPromise) {
            await (window as any).logoPromise;
        }

        await Promise.all([loadingTask.waitForFinish(), this.connectToServer()]);
        if (!loadingTask.isSuccess) {
            Lobby.error.handle(ErrorName.LOADING_FAILED);
            return;
        }

        this.enterGame();
    }

    protected enterGame(): void {
        director.loadScene(this.gameSceneName, async (err) => {
            if (err) {
                Lobby.error.handle(ErrorName.LOADING_FAILED);
                return;
            }
            Lobby.scene.enter(SceneName.OuterLobby);
            // if (Lobby.config.txGameID && !Lobby.hall.getGameDataByID(Lobby.hall.currentHallID, Lobby.config.txGameID)) {
            //     Lobby.error.handle(ErrorName.CONNECTION_FAILED);
            //     return;
            // }
            // back to last table if specifiedGameID is same as lastTable's gameID
            const lastTable = +Lobby.user.lastTable;
            if (lastTable) {
                let enterTableOption: Partial<EnterTableOption>;
                const targetTable = Lobby.hall.getTableByID(lastTable);
                if (targetTable) {
                    enterTableOption = { tableID: lastTable };
                }
                const table = Lobby.hall.getTableByID(lastTable);
                table.bettingModel.reconnect();
                const isEntered = await enterTableFlow.enter(enterTableOption, FeatureActivityDataType.EnterGameLocation.OuterLobby, true);
                if (isEntered) {
                    return;
                }
                table.bettingModel.reconnect(false);
            }

            Lobby.scene.enter(SceneName.OuterLobby);
            // Lobby.scene.enter(Lobby.config.txGameID ? SceneName.Lobby : SceneName.OuterLobby);
        });
    }

    protected async connectToServer() {
        const hallModel = Lobby.hall;
        this.connectProgress = 0.92;
        await Lobby.connection.connect();
        this.connectProgress = 0.95;
        await Lobby.user.login();
        this.connectProgress = 0.98;
        hallModel.requestOverviewData();
        await hallModel.waitForHallOverviewData();
        // await hallModel.waitForHallStatsData();
        this.connectProgress = 1;
    }

    private _updateProgress() {
        this.preloadView.updateProgress(this.loadingProgress * 0.9 + this.connectProgress * 0.1);
    }
}
